export default __webpack_public_path__ + "static/blob15-ae4bb617e65e7b62660be47626ec0d58.svg";